import { useTranslation } from 'react-i18next'

import TimesCircleErrorIcon from '@hapana/shared/web/styles/assets/svgs/times-circle-error.svg'
import AlertDialog from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.component'
import {
  SIZES,
  VARIANTS,
} from '@hapana/shared/web/components/shared/dialog/alert-dialog/alert-dialog.constants'
import { useDialog } from '@hapana/shared/web/components/shared/dialog/dialog.hooks'

export const TestEquipmentErrorAlert = () => {
  const { t } = useTranslation('checkIn')
  const { popDialog } = useDialog()

  return (
    <AlertDialog
      title={t('checkIn:equipments.alerts.testEquipment.errorTitle')}
      description={t('checkIn:equipments.alerts.testEquipment.errorDescription')}
      icon={TimesCircleErrorIcon}
      size={SIZES.XS}
      variant={VARIANTS.CRITICAL}
      closeAction={popDialog}
      primaryAction={{ label: t('checkIn:okay'), action: popDialog }}
    />
  )
}

export default TestEquipmentErrorAlert
